import { c as _c } from "react/compiler-runtime";
import type { FeedSegment } from "@/api";
import { HOME_SEGMENTS } from "@/lib/home-feed";
import { cn } from "@/lib/utils";

// Вкладки аудитории на стене «Идеи OSMIX» (кадр «Все идеи» 3846:152693): у
// левого края под заголовком, а не по центру, как на главной. Вкладка 40 в
// высоту с отступом 8 сверху, подпись 16/21 w500 (выбранная #1F1F1F, прочие
// #1F1F1F 48%), между вкладками 24, линия выбора 2px #FA5C2E, общая линия
// 1px #1F1F1F 8% по ширине группы. Сегменты те же, что на главной.
export function IdeaSegmentTabs(t0) {
  const $ = _c(5);
  const {
    active,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== active || $[1] !== onSelect) {
    t1 = HOME_SEGMENTS.map(s => {
      const selected = s.key === active;
      return <button key={s.key} type="button" role="tab" aria-selected={selected} onClick={() => onSelect(s.key)} className={cn("relative h-10 pt-2 text-left text-[16px] font-medium leading-[21px] outline-none transition-colors focus-visible:text-osmix-tangelo", selected ? "text-[#1F1F1F]" : "text-[#1F1F1F]/48 hover:text-[#1F1F1F]/70")}>{s.label}<span className={cn("absolute inset-x-0 -bottom-px h-0.5 rounded-[16px] bg-[#FA5C2E] transition-opacity", selected ? "opacity-100" : "opacity-0")} /></button>;
    });
    $[0] = active;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex w-fit gap-6 border-b border-[#1F1F1F]/[0.08]" role="tablist" aria-label={"\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0438\u044F"}>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}